export default {
	osvobodiSe: {
		title: 'Свобода без граници | Оптичен Интернет & ТВ от NetSurf',
		metaDescription:
			'Паузирай договора си до 5 месеца, вземи €30 за поканен приятел и имай интернет дори без ток. Гигабитова връзка и защита у дома от NetSurf.'
	},
	dovediPriyatel: {
		title: 'Вземи €30 отстъпка | Програма „Доведи приятел“ от NetSurf',
		metaDescription:
			'Изпрати €30 отстъпка за интернет и ТВ на авер, съсед или колега. При включване Страхил веднага ти приспада €30 и на теб от месечната такса! Без лимит на поканите.'
	},
	svoboda: {
		title: 'Програма Свобода | Договор за Интернет и ТВ на твоите правила',
		metaDescription:
			'Паузирай услугата до 5 месеца, сменяй плана нагоре или надолу без удължаване на договора и закови цената си без годишни поскъпвания с NetSurf.'
	},
	internetZashtita: {
		title: 'Закрилникът & Закрилник+ | Автоматичен щит от вируси у дома',
		metaDescription:
			'Автоматична защита от вируси и фишинг на ниво рутер без инсталация. Вземи пълен родителски контрол и графици за екраните със Закрилник+.'
	},
	tipTok: {
		title: 'TipTok Hem | Интернет и Телевизия без прекъсване дори БЕЗ ТОК',
		metaDescription:
			'Токът спира, интернетът — не! TipTok поема захранването на рутера за 0 милисекунди и ти осигурява до 2 часа стабилна връзка, докато кварталът е на тъмно.'
	},
	index: {
		title: 'Оптичен Интернет и Интерактивна Телевизия за всеки ',
		metaDescription:
			'Вземи своя пакет оптичен интернет и телевизия на супер цена от Netsurf. Покриваме те в Монтана, Враца, Благоевград, Лом, Вършец, Козлодуй, Берковица и др.'
	},
	home: {
		title: 'Интернет и Телевизия За Дома на супер цени ',
		metaDescription:
			'Възползвай се от най-добрите предложения за интернет и телевизия за твоя дом от Netsurf. Получаваш ултра висока скорост и много  програми. Увери се!'
	},
	homeIndefinite: {
		title: 'Домашен Интернет и Телевизия Без Договор',
		metaDescription:
			'Вземи своя нов пакет Оптичен Интернет и Интерактивна Телевизия Без Договор в Монтана, Благоевград, Враца, Лом, Берковица, Вършец, Оряхово и много други.'
	},
	business: {
		title: 'Надеждният интернет и телевизия за твоя бизнес ',
		metaDescription:
			'С Netsurf получаваш сигурен интернет и страхотна интерактивна телевизия за офиса. Довери се на най-надеждния партньор за твоя бизнес.'
	},
	coverage: {
		title: 'Покритие нашите услуги ',
		metaDescription:
			'Покриваме те в Монтана, Враца, Благоевград, Лом, Вършец, Козлодуй, Берковица, Оряхово, Кочериново, Селановци и още много други. Виж всики локации Тук!'
	},
	shops: {
		title: 'Нашите магазини и офиси в България ',
		metaDescription:
			'Очакваме те в най-близкия до теб офис на Netsurf в Монтана, Враца, Благоевград, Лом, Козлодуй и Берковица.'
	},
	terms: {
		title: 'Общи условия и Бланки',
		metaDescription:
			'Вашата поверителност е важна за нас и следователно е прозрачна за това как събираме, използваме и споделяме информация за вас. '
	},
	configurator: {
		title: 'Конфигуратор',
		metaDescription:
			'Подбери най-точния пакет лично за теб от свръхмодерен оптичен интернет и цифрова телевизия, като отговориш на само няколко въпроса! NetSurf мисли за теб.'
	},
	notfound: {
		title: 'Грешка 404',
		metaDescription:
			'Съвсем скоро ще видиш търсеното от теб съдържание. NetSurf ще те покрие с ултрамодерен GPON оптичен интерет и интерактивна телевизия.'
	},
	promo: {
		title: 'Промоции за Интернет и Телевизия',
		metaDescription:
			'Вземи своя промо пакет с неустоими предложения от Netsurf. Най-добрите условия с най-бързата скорост и много програми на страхотни цени само при нас.'
	},
	about: {
		title: 'Защо да избереш NetSurf',
		metaDescription:
			'Над 23 000 доволни клиента и вече над 25 години предлагаме най-качествените услуги за дома и бизнеса. Довери ни се!'
	},
	kakvoEGpon: {
		title: 'GPON оптичен Интернет и Телевизия',
		metaDescription:
			'Бъди неподвластен на времето с нашия ултра бърз интернет GPON.  Сърфираш с до 1000 Mbit/s и гледаш телевизия, дори когато няма ток. Опитай!'
	},
	netsurfplay: {
		title: 'NetSurf Play | Онлайн Телевизия и Управление на Акаунта',
		metaDescription:
			'Гледай любимите си канали навсякъде, плащай сметката за секунди и управлявай домашния си Wi-Fi рутер директно от телефона си с NetSurf Play.'
	},
	faq: {
		title: 'Помощ за всичките ти въпроси ',
		metaDescription:
			'Намери отговора на всеки твой въпрос в нашия сайт или по телефона. Нашият екип е винаги на твое разположение. Очакваме те!'
	},
	devices: {
		title: 'Онлайн Магазин за Устройства за ТВ и Интернет',
		metaDescription:
			'Избери продукт на изгодна цена от широката гама промоции на телевизори и таблети в новия ни онлайн магазин! Не е за вярване, а направо си е за действие!'
	},
	careers: {
		title: 'Кариери и свободни позиции ',
		metaDescription:
			'Присъедини се към нашия сплотен и млад екип. Очакваме те на нашия сайт с всички отворени позиции.'
	},
	assistant: {
		title: 'С NetSurf Assistant за да фиксваш вече и сам проблемите с нета си',
		metaDescription:
			'Новаторско приложение от NetSurf, с което разрешаваш проблемите с интернета светкавично. Изпробвай го! '
	}
};

